export default{
  DrinkWarnInfo (state, data) {
    if (data) state.drinkWarnInfo = data
  },
  PillsWarnInfo (state, data) {
    if (data) state.pillsWarnInfo = data
  },
  TomatoWarnInfo (state, data) {
    if (data) state.tomatoWarnInfo = data
  },
  PillsTimes (state, data) {
    if (data) state.pillsTimes = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js